import React from 'react'
import { WithTemplate } from '@morningtrain/react-app'
import { SmartviewMount } from '@morningtrain/react-smartviews'
import SmartviewContainer from 'widgets/smartviews/SmartviewContainer'
import TemplateContent from 'templates/TemplateContent'
import { OperationRepository } from '@morningtrain/react-resources'
import { AuthService } from '@morningtrain/react-auth'
import Toastify from 'services/Toastify'
import * as Errors from '@morningtrain/react-errors'

export default function AdminPageWithStickySmartview ({ defaultSmartviewSize = null, children }) {
  return (
    <OperationRepository>
      <AuthService reloadPageOnUnauthorized>
        <Toastify>
          <WithTemplate template='Admin'>
            <TemplateContent>
              <Errors.Boundary>
                {children}
              </Errors.Boundary>
            </TemplateContent>
            <SmartviewMount container={<SmartviewContainer defaultSmartviewSize={defaultSmartviewSize} />} />
          </WithTemplate>
        </Toastify>
      </AuthService>
    </OperationRepository>
  )
}
